"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateHeaders = exports.gqlClient = exports.gqlErrorFactory = exports.gqlQueryBuilder = exports.gqlQuery = void 0;
var core_1 = require("@apollo/client/core");
var context_1 = require("@apollo/client/link/context");
// Why cross-fetch: https://github.com/apollographql/apollo-link/issues/513
var cross_fetch_1 = __importDefault(require("cross-fetch"));
var localstorage_1 = require("./localstorage");
var gqlQuery = function (how) {
    return Object.keys(how).reduce(function (accumlulator, key) {
        var value = how[key];
        var typedValue = typeof value === 'string' ? "\"" + value + "\"" : value;
        return "" + accumlulator + key + ":" + typedValue + ",";
    }, '');
};
exports.gqlQuery = gqlQuery;
var gqlQueryBuilder = function (fct, how, fields) {
    var query = exports.gqlQuery(how);
    return fct + "(" + query + "){" + fields + "}";
};
exports.gqlQueryBuilder = gqlQueryBuilder;
var gqlErrorFactory = function (err) {
    var _a, _b;
    var error = (_a = err === null || err === void 0 ? void 0 : err.networkError) === null || _a === void 0 ? void 0 : _a.result;
    return {
        data: error === null || error === void 0 ? void 0 : error.data,
        message: (error ? (_b = error === null || error === void 0 ? void 0 : error.errors[0]) === null || _b === void 0 ? void 0 : _b.message : err.message),
    };
};
exports.gqlErrorFactory = gqlErrorFactory;
var authLink = context_1.setContext(function (_, _a) {
    var headers = _a.headers;
    return ({ headers: headers });
});
var defaultOptions = {
    watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
    },
    query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    },
};
var gqlClient = function (url) {
    var _a;
    var marketplaceToken = localstorage_1.getTokens().marketplaceToken;
    var uri = (_a = localstorage_1.getStorageByKey('mkpApiUrl')) !== null && _a !== void 0 ? _a : undefined;
    var httpLink = new core_1.HttpLink({ uri: url !== null && url !== void 0 ? url : uri, fetch: cross_fetch_1.default, headers: {
            authorization: marketplaceToken ? "Bearer " + marketplaceToken : '',
        } });
    return new core_1.ApolloClient({
        // Important check in details and implement caching when most of network is coming from gql
        // https://www.apollographql.com/docs/react/caching/cache-configuration/
        cache: new core_1.InMemoryCache(),
        defaultOptions: defaultOptions,
        link: authLink.concat(httpLink),
    });
};
exports.gqlClient = gqlClient;
var updateHeaders = function (instance, headers) {
    var uri = localstorage_1.getStorageByKey('mkpApiUrl');
    var entries = Object.entries(headers);
    var cleanHeaders = entries.reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        if (value) {
            return __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b));
        }
        return acc;
    }, { 'content-type': 'application/json' });
    if (uri) {
        // Unfortunately there is no way to reuse link or url from ApolloClient instance
        var httpLink = new core_1.HttpLink({ uri: uri, fetch: cross_fetch_1.default, headers: cleanHeaders });
        instance.setLink(httpLink);
    }
    return true;
};
exports.updateHeaders = updateHeaders;
